// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"c8a6c4dc","230":"9d51d654","654":"b4b08c94"}[chunkId] + ".chunk.js";
};